/* @ngInject */
const scrappingMenu = () => {
  const self = {}

  return self
}
export default scrappingMenu



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/scrapping/scrapping.menu.js